import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointService } from '@core/services/breakpoint.service';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent {
  @Input() public title: string | Observable<string>;
  constructor(public readonly breakpointService: BreakpointService) {}
}
